import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import Integrations from "assets/icon/integration-sidebar.svg";
import Admin from "assets/icon/admin.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PatientsIcon from "assets/icon/Patients-icon.svg";

import { Collapse, Navbar } from "reactstrap";
import dashboardIconDark from "../assets/sidebar/dasboard-purple-icon.svg";
import dashboardIconLight from "../assets/sidebar/dashboardIcon-light.svg";
import orderentryIconDark from "../assets/sidebar/orderentryIcon-dark.svg";
import orderentryIconLight from "../assets/sidebar/orderentryIcon-light.svg";
import claimsIconDark from "../assets/sidebar/claimsIcon-dark.svg";
import claimsIconLight from "../assets/sidebar/claimsIcon-light.svg";
import initialRiewDarkIcon from "../assets/sidebar/initialReviewIcon-dark.svg";
import initialReviewIconLight from "../assets/sidebar/initialReviewIcon-light.svg";
import packagingIconDark from "../assets/sidebar/packagingIcon-dark.svg";
import packagingIconLight from "../assets/sidebar/packagingIcon-light.svg";
import finalIconLight from "../assets/sidebar/finalReviewIcon-light.svg";
import finalIconDark from "../assets/sidebar/finalReviewIcon-dark.svg";
import pendingIconDark from "../assets/sidebar/pendingIcon-dark.svg";
import pendingIconLight from "../assets/sidebar/pendingIcon-light.svg";
import workflowGrayIcon from "../assets/icon/workflow-gray-icon.svg";
import workflowWhiteIcon from "../assets/icon/workflow-white-icon.svg";
import topWhiteArrow from "../assets/icon/top-white-arrow.svg";
import bottomPurpleArrow from "../assets/icon/bottom-purple-arrow.svg";
import InventorySideBar from "./InventorySideBar";
import paitentDarkIcon from "assets/icon/dark-paitent-icon.svg";
import ReportsSideBar from "./ReportsSideBar";

function SiderBar() {
  const savedActive =
    sessionStorage.getItem("activeTab") || "/workflow-dashboard";
  const savedActiveMenu = sessionStorage.getItem("activeMenu") || "nav";
  const [active, setActive] = useState(savedActive);
  const [activeMenu, setActiveMenu] = useState(savedActiveMenu);
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.setItem("activeTab", active);
    sessionStorage.setItem("activeMenu", activeMenu);
  }, [active, activeMenu]);

  const handleClick = (link) => {
    setActive(link);
  };

  const toggleMenu = (menu, link, activeColor) => {
    setActiveMenu(activeMenu === !menu ? null : menu);
    setActive(activeColor);
    navigate(link);
  };
  const location = useLocation();

  return (
    <>
      <Navbar>
        <Nav navbar className="flex-column">
          <NavItem>
            <NavLink
              to="/workflow-dashboard"
              className={`link-container ${
                location.pathname.startsWith("/workflow")
                  ? "active-btn"
                  : "nav-button"
              }`}
              onClick={() =>
                toggleMenu("nav", "/workflow-dashboard", "/workflow-dashboard")
              }
            >
              <span>
                <img
                  // className={
                  //   location.pathname.startsWith("/workflow") ? "workflow-img" : "workflow-text"
                  // }
                  src={
                    location.pathname.startsWith("/workflow")
                      ? workflowWhiteIcon
                      : workflowGrayIcon
                  }
                />{" "}
                <span
                  className={
                    location.pathname.startsWith("/workflow")
                      ? "workflow-header"
                      : "workflow-text"
                  }
                >
                  {" "}
                  Workflow
                </span>
              </span>

              <img
                className="work-flow-arrow"
                src={
                  location.pathname.startsWith("/workflow")
                    ? topWhiteArrow
                    : bottomPurpleArrow
                }
              />
            </NavLink>
          </NavItem>
          <Collapse isOpen={location.pathname.startsWith("/workflow")}>
            <Nav
              navbar
              vertical
              // style={{
              //   marginLeft: "20px",
              //   marginBottom: "5px",
              //   marginTop: "5px",
              // }}
            >
              <NavItem className="">
                <NavLink>
                  <Link
                    onClick={() => handleClick("/workflow-dashboard")}
                    className="link-container"
                    to="/workflow-dashboard"
                    style={{
                      color:
                        location.pathname === "/workflow-dashboard"
                          ? "#542149"
                          : "",
                    }}
                  >
                    <div className="hoverFix workflow-text workflow-small ">
                      <div className="side-margin">
                        <img
                          src={
                            location.pathname === "/workflow-dashboard"
                              ? dashboardIconDark
                              : dashboardIconLight
                          }
                          alt="Dashboard Icon"
                          className="workflow-icon"
                        />
                        <span
                          style={{
                            fontWeight:
                              location.pathname === "/workflow-dashboard"
                                ? "600"
                                : "",
                          }}
                        >
                          Dashboard
                        </span>
                      </div>
                      {/* <span className="workflow-text workflow-small">
                        
                        </span> */}
                    </div>
                  </Link>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink>
                  <Link
                    className="link-container"
                    onClick={() => handleClick("/patients")}
                    style={{
                      color: location.pathname.startsWith("/workflow-patients")
                        ? "#542149"
                        : "", // Active color for the link
                    }}
                    to="/workflow-patients"
                  >
                    <div className="hoverFix workflow-text workflow-small ">
                      <div className="side-margin">
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname.startsWith("/workflow-patients")
                              ? PatientsIcon
                              : paitentDarkIcon
                          } // Dynamically use image based on pathname
                          // alt="Home Icon"
                        />
                        <span
                          style={{
                            verticalAlign: "middle",
                            fontWeight: location.pathname.startsWith(
                              "/workflow-patients"
                            )
                              ? "600"
                              : "", // Bold font for location.pathname state
                          }}
                        >
                          Patients
                        </span>
                      </div>
                    </div>
                  </Link>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink>
                  <Link
                    className="link-container"
                    onClick={() => handleClick("/workflow-orderEntry")}
                    style={{
                      color: location.pathname.startsWith(
                        "/workflow-orderEntry"
                      )
                        ? "#542149"
                        : "",
                    }}
                    to="/workflow-orderEntry"
                  >
                    <div className="hoverFix workflow-text workflow-small">
                      {" "}
                      <div className="side-margin">
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname.startsWith("/workflow-orderEntry")
                              ? orderentryIconDark
                              : orderentryIconLight
                          }
                          alt=""
                        />
                        <span
                          style={{
                            fontWeight: location.pathname.startsWith(
                              "/workflow-orderEntry"
                            )
                              ? "600"
                              : "",
                          }}
                        >
                          Order Entry{" "}
                        </span>
                      </div>
                      <div
                        className="workflow-text workflow-small"
                        style={{
                          fontWeight: location.pathname.startsWith(
                            "/workflow-orderEntry"
                          )
                            ? "600"
                            : "",
                        }}
                      >
                        (112)
                      </div>
                    </div>
                  </Link>
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink>
                  <Link
                    className="link-container"
                    to="/workflow-claims"
                    onClick={() => handleClick("/workflow-claims")}
                    style={{
                      color:
                        location.pathname === "/workflow-claims"
                          ? "#542149"
                          : "",
                    }}
                  >
                    <div className="hoverFix workflow-text workflow-small">
                      <div className="side-margin">
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname == "/workflow-claims"
                              ? claimsIconDark
                              : claimsIconLight
                          }
                          alt=""
                        />
                        <span
                          style={{
                            fontWeight:
                              location.pathname === "/workflow-claims"
                                ? "600"
                                : "",
                          }}
                        >
                          Claims
                        </span>
                      </div>
                      <div
                        className=""
                        style={{
                          fontWeight:
                            location.pathname === "/workflow-claims"
                              ? "600"
                              : "",
                        }}
                      >
                        (89)
                      </div>
                    </div>
                  </Link>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink>
                  <Link
                    className="link-container"
                    to="/workflow-initial"
                    onClick={() => handleClick("/workflow-initial")}
                    style={{
                      color: location.pathname.startsWith("/workflow-initial")
                        ? "#542149"
                        : "",
                    }}
                  >
                    <div className="hoverFix  workflow-text workflow-small">
                      <div className="side-margin">
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname.startsWith("/workflow-initial")
                              ? initialRiewDarkIcon
                              : initialReviewIconLight
                          }
                          alt=""
                        />
                        <span
                          style={{
                            fontWeight: location.pathname.startsWith(
                              "/workflow-initial"
                            )
                              ? "600"
                              : "",
                          }}
                        >
                          Initial Review
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: location.pathname.startsWith(
                            "/workflow-initial"
                          )
                            ? "600"
                            : "",
                        }}
                      >
                        (89)
                      </div>
                    </div>
                  </Link>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink>
                  <Link
                    className="link-container"
                    to="/workflow-packaging"
                    onClick={() => handleClick("/workflow-packaging")}
                    style={{
                      color: location.pathname.startsWith("/workflow-packaging")
                        ? "#542149"
                        : "",
                    }}
                  >
                    <div className="hoverFix workflow-text workflow-small">
                      <div className="side-margin">
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname.startsWith("/workflow-packaging")
                              ? packagingIconDark
                              : packagingIconLight
                          }
                          alt=""
                        />
                        <span
                          style={{
                            fontWeight: location.pathname.startsWith(
                              "/workflow-packaging"
                            )
                              ? "600"
                              : "",
                          }}
                        >
                          Packaging
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: location.pathname.startsWith(
                            "/workflow-packaging"
                          )
                            ? "600"
                            : "",
                        }}
                      >
                        (12)
                      </div>
                    </div>
                  </Link>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink>
                  <Link
                    className="link-container"
                    to="/workflow-final"
                    onClick={() => handleClick("/workflow-final")}
                    style={{
                      color: location.pathname.startsWith("/workflow-final")
                        ? "#542149"
                        : "",
                    }}
                  >
                    <div className="hoverFix workflow-text workflow-small">
                      <div className="side-margin">
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname.startsWith("/workflow-final")
                              ? finalIconDark
                              : finalIconLight
                          }
                          alt=""
                        />
                        <span
                          style={{
                            fontWeight: location.pathname.startsWith(
                              "/workflow-final"
                            )
                              ? "600"
                              : "",
                          }}
                        >
                          Final Review
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: location.pathname.startsWith(
                            "/workflow-final"
                          )
                            ? "600"
                            : "",
                        }}
                      >
                        (89)
                      </div>
                    </div>
                  </Link>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink>
                  <Link
                    className="link-container"
                    to="/workflow-pending"
                    onClick={() => handleClick("/workflow-pending")}
                    style={{
                      color:
                        location.pathname === "/workflow-pending"
                          ? "#542149"
                          : "",
                    }}
                  >
                    <div className="hoverFix workflow-text workflow-small">
                      <div className="side-margin">
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname == "/workflow-pending"
                              ? pendingIconDark
                              : pendingIconLight
                          }
                          alt=""
                        />
                        <span
                          style={{
                            fontWeight:
                              location.pathname === "/workflow-pending"
                                ? "600"
                                : "",
                          }}
                        >
                          Pending
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight:
                            location.pathname === "/workflow-pending"
                              ? "600"
                              : "",
                        }}
                      >
                        (22)
                      </div>
                    </div>
                  </Link>
                </NavLink>
              </NavItem>
            </Nav>
            <div className="sep"></div>
          </Collapse>

          {/* Navigation Two */}
          {/* <NavItem>
              <NavLink
                href="#"
                className={`link-container ${
                  activeMenu === "nav2" ? "location.pathname-btn " : "nav-button"
                }`}
                onClick={() => toggleMenu("nav2")}
              >
                <span>
                  <img
                    className={
                      activeMenu === "nav2"
                        ? "workflow-header"
                        : "workflow-text"
                    }
                    src={activeMenu === "nav2" ? invontoryWhiteIcon : Inventory}
                  />{" "}
                  <span
                    className={
                      activeMenu === "nav2"
                        ? "workflow-header"
                        : "workflow-text"
                    }
                  >
                    Inventory
                  </span>
                </span>
                <span>
                  <img
                    src={
                      activeMenu === "nav2" ? topWhiteArrow : bottomPurpleArrow
                    }
                  />
                </span>
              </NavLink>
              <Collapse isOpen={activeMenu === "nav2"} className="ms-4">
                <Nav navbar vertical>
                  <NavItem>
                    <NavLink>
                      <Link
                        className="link-container"
                        to="/pending"
                        onClick={() => handleClick("/pending")}
                        style={{
                          color: location.pathname === "/pending" ? "#542149" : "",
                        }}
                      >
                        <img
                          className="workflow-icon"
                          src={
                            location.pathname == "/pending"
                              ? pendingIconDark
                              : pendingIconLight
                          }
                          alt=""
                        />
                        <span className="workflow-text">Dashboard</span>
                      </Link>
                    </NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
            </NavItem> */}
          <InventorySideBar
            title={"Inventory"}
            toggles={() =>
              toggleMenu(
                "Inventory",
                "/inventory-dashboard",
                "/inventory-dashboard"
              )
            }
            menuactive={activeMenu}
            activeText={location.pathname}
            setActiveText={handleClick}
          />
          <ReportsSideBar
            title={"Reports"}
            toggles={() =>
              toggleMenu("Reports", "/reports-dashboard", "/reports-dashboard")
            }
            menuactive={activeMenu}
            activeText={location.pathname}
            setActiveText={handleClick}
          />
          <NavItem style={{ marginLeft: "8px", marginBottom: "10px" }}>
            <NavLink
              className="link-container"
              to="/integration"
              onClick={() => handleClick("/integration")}
              style={{
                color: location.pathname === "/integration" ? "#542149" : "",
              }}
            >
              <div>
                <img src={Integrations} />
                <span className="workflow-text" style={{ marginLeft: "8px" }}>
                  Integrations
                </span>
              </div>
            </NavLink>
          </NavItem>
          <NavItem style={{ marginLeft: "8px", marginBottom: "10px" }}>
            <NavLink
              className="link-container"
              to="/admin"
              onClick={() => handleClick("/admin")}
              style={{
                color: location.pathname === "/admin" ? "#542149" : "",
              }}
            >
              <div className="hoverColor">
                <img src={Admin} />
                <span className="workflow-text " style={{ marginLeft: "8px" }}>
                  Admin
                </span>
              </div>
            </NavLink>
          </NavItem>
        </Nav>
      </Navbar>
    </>
  );
}

export default SiderBar;
